"use client";
import { Toast } from "@ark-ui/react/toast";
import { toast, } from "@filadd/phi-plus-styled-system/recipes";
import { createStyleContext } from "../../utils";
const { withProvider, withContext } = createStyleContext(toast);
export const Root = withProvider(Toast.Root, "root");
export const ActionTrigger = withContext(Toast.ActionTrigger, "actionTrigger");
export const CloseTrigger = withContext(Toast.CloseTrigger, "closeTrigger");
export const Description = withContext(Toast.Description, "description");
export const Title = withContext(Toast.Title, "title");
export { ToastContext as Context, createToaster, Toaster, } from "@ark-ui/react/toast";
//# sourceMappingURL=BaseToast.js.map